// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"cf81402d","253":"ccbd4f88","684":"6496fe37"}[chunkId] + ".chunk.css";
};